import TextContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/TextContent";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import PlaceholderEvent from "../event/PlaceholderEvent";

export default class PlaceholderCommand extends AbstractCommand {
    constructor(dispatcher) {
        super(dispatcher);
    }

    execute(evt) {
        const data = evt.params.data;

        /** @type {TextContent} */
        this._content = data.content;
        /** @type {NGTScenarioPlayer} */
        this._contentPlayer = data.contentPlayer;

        this._handleCloseBound = this._handleClose.bind(this);
        this._dispatcher.addEventListener(PlaceholderEvent.CLOSE_REQUEST, this._handleCloseBound);

        this._screenSkin = this.openScreen(SkinKeyRegistry.PLACEHOLDER_SCREEN_SKIN, {}, {
            content: this._content,
        });
    }

    _handleClose() {
        this._dispatcher.removeEventListener(PlaceholderEvent.CLOSE_REQUEST, this._handleCloseBound);

        this.closeScreen(this._screenSkin);
        
        this._contentPlayer.contentCompleted(this._content);
    }
}